module.exports = __webpack_public_path__ + "media/images/delete2-36f6d51395b878f6078622d933d50a1d.svg";